import { gql } from "@apollo/client";
import { quotation } from "../comparator/fragments";

export const QUOTATIONS_QUERY = gql`
  query quotations($documentId: Int!) {
    quotations(documentId: $documentId) {
      documentId
      quotations {
        ...quotation
      }
    }
  }
  ${quotation}
`;
